var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('MainNav'),_c('PageTitle',{attrs:{"title":"Team"}}),_c('div',{staticClass:"people__title"},[_vm._v(_vm._s(_vm.$t("people.ourTeam")))]),_c('div',{staticClass:"people__container"},_vm._l((_vm.people),function(person,index){return _c('Person',{key:index,attrs:{"person":person}})}),1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }